/* City selector: Jeddah / Riyadh — shows stock for the chosen city; each button also sets the site language. */
(function () {
  'use strict';
  var CS = window.CityStock;
  if (!CS || window.__csInit) return;
  window.__csInit = true;

  var cfg = CS.config;
  var t = cfg.t;
  var KEY = 'mg-delivery-city';

  /* ---------- data ---------- */
  var variants = {};
  Object.keys(CS.products || {}).forEach(function (h) {
    var p = CS.products[h];
    Object.keys(p).forEach(function (id) { variants[id] = p[id]; });
  });
  Object.keys(CS.cartItems || {}).forEach(function (id) { variants[id] = CS.cartItems[id]; });

  function getCity() {
    try {
      var c = localStorage.getItem(KEY);
      return cfg.cities[c] ? c : null;
    } catch (e) { return null; }
  }
  function setCityStore(c) { try { localStorage.setItem(KEY, c); } catch (e) {} }
  function cityLabel(c) { return cfg.cities[c].label; }
  function fmt(s, o) { return s.replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }

  /* qty for a variant in a city: number, or null when unknown (never block unknown) */
  function stockOf(variantId, city) {
    var row = variants[String(variantId)];
    if (!row || !city) return null;
    var q = row[cfg.cities[city].index];
    return (typeof q === 'number') ? q : null;
  }

  /* remembers lines we trimmed to the city's stock, so the cart can explain why */
  var CAP_KEY = 'mg-capped-lines';
  function getCapped() { try { return JSON.parse(sessionStorage.getItem(CAP_KEY) || '{}'); } catch (e) { return {}; } }
  function saveCapped(o) { try { sessionStorage.setItem(CAP_KEY, JSON.stringify(o)); } catch (e) {} }
  function rememberCap(vid, requested, city) { var o = getCapped(); o[String(vid)] = { req: requested, city: city }; saveCapped(o); }

  /* ---------- UI helpers ---------- */
  var PIN = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z"/><circle cx="12" cy="10" r="2.6"/></svg>';

  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'cs-toast';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 6000);
  }

  var modal;
  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cs-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'cs-title');
    if (cfg.rtl) modal.setAttribute('dir', 'rtl');
    document.body.appendChild(modal);
    return modal;
  }
  function openModal(html, onReady) {
    buildModal();
    modal.innerHTML = '<div class="cs-modal__bg"></div><div class="cs-modal__box">' + html + '</div>';
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (onReady) onReady(modal);
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  /* one row of city buttons per store language; the page's own language comes first */
  function pickerLangs() {
    var langs = (cfg.langs || []).filter(function (l) { return cfg.cityNames[l]; });
    if (langs.indexOf(cfg.lang) < 0) langs.unshift(cfg.lang);
    return langs.sort(function (a, b) { return (b === cfg.lang) - (a === cfg.lang); });
  }

  function openCityPicker() {
    var cur = getCity();
    var langs = pickerLangs();
    var rows = langs.map(function (l) {
      var btns = Object.keys(cfg.cities).map(function (c) {
        return '<button type="button" lang="' + l + '" class="cs-city-btn' + (c === cur && l === cfg.lang ? ' is-current' : '') + '" data-cs-city="' + c + '" data-cs-lang="' + l + '">' + cfg.cityNames[l][c] + '</button>';
      }).join('');
      return (langs.length > 1 ? '<p class="cs-modal__lang" lang="' + l + '">' + cfg.langNames[l] + '</p>' : '') +
        '<div class="cs-modal__btns">' + btns + '</div>';
    }).join('');
    openModal(
      '<div class="cs-modal__pin">' + PIN + '</div>' +
      '<h2 class="cs-modal__title" id="cs-title">' + t.title + '</h2>' +
      '<p class="cs-modal__sub">' + t.subtitle + '</p>' +
      rows +
      '<p class="cs-modal__note">' + t.note + '</p>',
      function (m) {
        var first = m.querySelector('.cs-city-btn');
        if (first) first.focus();
        m.querySelectorAll('[data-cs-city]').forEach(function (b) {
          b.addEventListener('click', function () { chooseCity(b.getAttribute('data-cs-city'), b.getAttribute('data-cs-lang')); });
        });
      }
    );
  }

  function chooseCity(c, lang) {
    var prev = getCity();
    setCityStore(c);
    closeModal();
    var saved = syncCartAttribute(c);
    if (lang && lang !== cfg.lang && switchLanguage(lang, saved)) return;
    renderAll();
    if (prev && prev !== c) checkCart(false);
  }

  /* reload the page in the language of the button: Shopify's localization form keeps the same page */
  function switchLanguage(lang, saved) {
    var form = document.getElementById('cs-lang-form');
    var input = form && form.querySelector('[name="language_code"]');
    if (!input || (cfg.langs || []).indexOf(lang) < 0) return false;
    input.value = lang;
    var go = function () { HTMLFormElement.prototype.submit.call(form); };
    // wait for the city to reach the cart (at most 1.5 s) so the next page already knows it
    Promise.race([saved, new Promise(function (r) { setTimeout(r, 1500); })]).then(go, go);
    return true;
  }

  /* ---------- cart attributes: our city + Bird Pickup & Delivery's location fields ---------- */
  // Values Bird itself writes for each location (taken from real orders).
  var BIRD = {
    jeddah: { 'Delivery Location': 'Ibn Qasim Al Khawarizmi, Al Bawadi , Jeddah, , SA, 23443', 'locationId': '35478', 'shopifyLocationId': '68216062146' },
    riyadh: { 'Delivery Location': 'الرياض الرياض, Riyadh, , SA, 12211', 'locationId': '113995', 'shopifyLocationId': '85072707778' }
  };
  function syncCartAttribute(c) {
    var val = cfg.cities[c].attr;
    var bird = BIRD[c];
    if (cfg.birdMethod === 'Pickup') bird = null; // never override a pickup choice
    var birdOk = !bird || cfg.cartBirdLoc === bird.shopifyLocationId;
    if (cfg.cartCity === val && birdOk) return Promise.resolve();
    var attrs = { 'Delivery City': val };
    if (bird && !birdOk) {
      Object.keys(bird).forEach(function (k) { attrs[k] = bird[k]; });
      // a date picked for the other city may not be valid here: let the customer pick again
      if (cfg.cartBirdLoc) { attrs['Delivery Date'] = ''; attrs['Delivery Day'] = ''; }
    }
    cfg.cartCity = val;
    if (bird) cfg.cartBirdLoc = bird.shopifyLocationId;
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* If Bird saves the other city's location onto the cart, swap in the chosen city's values. */
  function fixBirdAttributes(body, city) {
    var bird = BIRD[city];
    if (!bird) return null;
    try {
      if (typeof body === 'string' && body.trim().charAt(0) === '{') {
        var j = JSON.parse(body);
        var a = j.attributes;
        if (!a || !('shopifyLocationId' in a || 'locationId' in a || 'Delivery Location' in a)) return null;
        if (a['Delivery Method'] === 'Pickup') return null;
        if (a.shopifyLocationId === bird.shopifyLocationId && a.locationId === bird.locationId) return null;
        Object.keys(bird).forEach(function (k) { a[k] = bird[k]; });
        return JSON.stringify(j);
      }
      var get, set, isFD = typeof FormData !== 'undefined' && body instanceof FormData, sp;
      if (isFD) { get = function (k) { return body.get(k); }; }
      else if (typeof body === 'string' || body instanceof URLSearchParams) {
        sp = new URLSearchParams(body.toString()); get = function (k) { return sp.get(k); };
      } else return null;
      var key = function (k) { return 'attributes[' + k + ']'; };
      if (get(key('shopifyLocationId')) == null && get(key('locationId')) == null && get(key('Delivery Location')) == null) return null;
      if (get(key('Delivery Method')) === 'Pickup') return null;
      if (get(key('shopifyLocationId')) === bird.shopifyLocationId && get(key('locationId')) === bird.locationId) return null;
      if (isFD) {
        var fd = new FormData();
        body.forEach(function (v, k) { fd.append(k, v); });
        Object.keys(bird).forEach(function (k) { fd.set(key(k), bird[k]); });
        return fd;
      }
      Object.keys(bird).forEach(function (k) { sp.set(key(k), bird[k]); });
      return typeof body === 'string' ? sp.toString() : sp;
    } catch (e) { return null; }
  }

  /* ---------- top bar ---------- */
  function renderBar(city) {
    var bar = document.querySelector('.cs-bar');
    if (!city) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'cs-bar';
      if (cfg.rtl) bar.setAttribute('dir', 'rtl');
      var main = document.getElementById('main');
      if (main) main.insertBefore(bar, main.firstChild); else document.body.insertBefore(bar, document.body.firstChild);
    }
    bar.innerHTML = PIN + '<span>' + t.deliveringTo + ' <strong>' + cityLabel(city) + '</strong></span> · <button type="button" data-cs-change>' + t.change + '</button>';
    bar.querySelector('[data-cs-change]').addEventListener('click', openCityPicker);
  }

  /* ---------- product cards ---------- */
  function handleFromHref(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function renderCards(city) {
    document.querySelectorAll('[data-js-product-item]').forEach(function (card) {
      var old = card.querySelector('.cs-badge');
      if (old) old.remove();
      card.classList.remove('cs-out');
      if (!city) return;
      var link = card.querySelector('a[href*="/products/"]');
      var p = link && CS.products[handleFromHref(link.getAttribute('href'))];
      if (!p) return;
      var total = 0, unknown = false;
      Object.keys(p).forEach(function (id) {
        var q = stockOf(id, city);
        if (q === null) unknown = true; else total += Math.max(q, 0);
      });
      if (unknown) return;
      var img = card.querySelector('.product-item__image') || card;
      var badge = document.createElement('span');
      if (total <= 0) {
        card.classList.add('cs-out');
        badge.className = 'cs-badge cs-badge--out';
        badge.textContent = fmt(t.soldOutIn, { city: cityLabel(city) });
      } else if (total <= cfg.lowStock && total < 999) {
        badge.className = 'cs-badge cs-badge--low';
        badge.textContent = fmt(t.onlyLeft, { n: total, city: cityLabel(city) });
      } else return;
      img.appendChild(badge);
    });
  }

  /* ---------- product forms (product page, quick view) ---------- */
  function renderForms(city) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.closest('[data-js-product-item]')) return; // card quick-buy handled by card + fetch guard
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      var vid = idInput.value;
      var q = stockOf(vid, city);
      var btn = form.querySelector('button[type="submit"], button[name="add"], [data-js-product-add-to-cart]');
      var status = form.parentNode.querySelector('.cs-status[data-form-status]');

      if (q === null) {
        if (status) status.remove();
        restoreButton(btn);
        form.classList.remove('cs-form-out');
        return;
      }
      if (!status) {
        status = document.createElement('div');
        status.className = 'cs-status';
        status.setAttribute('data-form-status', '');
        status.setAttribute('aria-live', 'polite');
        form.parentNode.insertBefore(status, form.nextSibling);
      }
      var label = cityLabel(city), cls = 'cs-status', text;
      if (q <= 0) {
        cls += ' cs-status--out';
        text = fmt(t.soldOutIn, { city: label });
        form.classList.add('cs-form-out');
        if (btn) {
          if (!btn.hasAttribute('data-cs-orig')) btn.setAttribute('data-cs-orig', btn.innerHTML);
          if (!btn.disabled || btn.getAttribute('data-cs-disabled') !== '1') {
            btn.disabled = true;
            btn.setAttribute('data-cs-disabled', '1');
            var inner = btn.querySelector('.button__text, span') || btn;
            inner.textContent = text;
          }
        }
      } else {
        form.classList.remove('cs-form-out');
        restoreButton(btn);
        if (q <= cfg.lowStock && q < 999) { cls += ' cs-status--low'; text = fmt(t.onlyLeft, { n: q, city: label }); }
        else text = fmt(t.inStock, { city: label });
      }
      if (status.className !== cls) status.className = cls;
      if (status.textContent !== text) status.textContent = text;
    });
  }
  function restoreButton(btn) {
    if (btn && btn.getAttribute('data-cs-disabled') === '1') {
      btn.innerHTML = btn.getAttribute('data-cs-orig');
      btn.disabled = false;
      btn.removeAttribute('data-cs-disabled');
      btn.removeAttribute('data-cs-orig');
    }
  }

  /* ---------- cart lines (drawer + cart page): flag sizes short in the city, block checkout ---------- */
  var EXPRESS = 'shopify-accelerated-checkout-cart, .additional-checkout-buttons, .dynamic-checkout__content';
  function renderCart(city) {
    var lines = document.querySelectorAll('[data-js-cart-item][data-id]');
    var blocked = false;
    var capped = getCapped(), cappedDirty = false;
    lines.forEach(function (line) {
      var flag = line.querySelector('.cs-line-flag');
      var vid = String(line.getAttribute('data-id')).split(':')[0];
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 0;
      var q = city ? stockOf(vid, city) : null;
      var text = null, cls = 'cs-line-flag';
      if (q !== null && qty > q) {
        blocked = true;
        line.classList.add('cs-line-out');
        text = q <= 0 ? fmt(t.soldOutIn, { city: cityLabel(city) }) : fmt(t.notEnough, { n: q, city: cityLabel(city) });
      } else {
        line.classList.remove('cs-line-out');
        var cap = capped[vid];
        if (cap && q !== null && cap.city === city && qty === q && cap.req > q) {
          cls += ' cs-line-flag--info';
          text = fmt(t.cappedLine, { req: cap.req, n: q, city: cityLabel(city) });
        } else if (cap && (q === null || cap.city !== city || qty < q)) {
          delete capped[vid]; cappedDirty = true;
        }
      }
      if (!text) { if (flag) flag.remove(); return; }
      if (!flag) {
        flag = document.createElement('span');
        (line.querySelector('.cart-item__actions') || line).insertAdjacentElement('beforebegin', flag);
      }
      if (flag.className !== cls) flag.className = cls;
      if (flag.textContent !== text) flag.textContent = text;
    });

    if (cappedDirty) saveCapped(capped);

    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      var holder = btn.closest('form') || btn.parentNode;
      var note = holder.querySelector('.cs-checkout-note');
      if (blocked) {
        btn.disabled = true;
        btn.classList.add('cs-checkout-blocked');
        if (!note) {
          note = document.createElement('div');
          note.className = 'cs-checkout-note';
          note.setAttribute('role', 'alert');
          btn.insertAdjacentElement('beforebegin', note);
        }
        var msg = fmt(t.cartIssues, { city: cityLabel(city) }).replace(/:$/, '.') + ' ' + t.cartFix;
        if (note.textContent !== msg) note.textContent = msg;
      } else if (btn.classList.contains('cs-checkout-blocked')) {
        btn.disabled = false;
        btn.classList.remove('cs-checkout-blocked');
        if (note) note.remove();
      }
    });
    document.querySelectorAll(EXPRESS).forEach(function (el) {
      el.classList.toggle('cs-express-hidden', blocked);
    });
  }

  /* ---------- Bird delivery widget on the cart page: follow the chosen city, hide its location dropdown ---------- */
  var BIRD_LOCATION = { jeddah: 'jeddah city', riyadh: 'riyadh city' };
  function syncBirdLocation(city) {
    if (!city) return;
    document.querySelectorAll('select').forEach(function (sel) {
      var opts = Array.prototype.slice.call(sel.options || []);
      var texts = opts.map(function (o) { return (o.textContent || '').trim().toLowerCase(); });
      if (texts.indexOf('jeddah city') < 0 && texts.indexOf('riyadh city') < 0) return;
      var match = opts[texts.indexOf(BIRD_LOCATION[city])];
      if (!match) { sel.classList.remove('cs-bird-hidden'); return; } // city not offered: leave visible
      if (sel.value !== match.value) {
        var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
        setter.call(sel, match.value);
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (!sel.classList.contains('cs-bird-hidden')) {
        sel.classList.add('cs-bird-hidden');
        var wrap = sel.parentElement;
        var label = (sel.id && document.querySelector('label[for="' + sel.id + '"]')) ||
          (wrap && wrap.previousElementSibling && /موقع|location/i.test(wrap.previousElementSibling.textContent || '') ? wrap.previousElementSibling : null) ||
          (sel.previousElementSibling && /موقع|location/i.test(sel.previousElementSibling.textContent || '') ? sel.previousElementSibling : null);
        if (label) label.classList.add('cs-bird-hidden');
        if (wrap && wrap.children.length === 1 && wrap !== label) wrap.classList.add('cs-bird-hidden');
      }
    });
  }

  /* ---------- Bird's delivery note: drop the city name (customer already chose it) ---------- */
  var CITY_IN_NOTE = /\s*(?:داخل|في)\s+(?:مدينة\s+)?(?:جدة|جده|الرياض)|\s*(?:with)?in\s+(?:Jeddah|Riyadh)(?:\s+city)?/gi;
  function cleanNoteIn(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var v = n.nodeValue;
      if (!v || v.length > 400 || !/(التوصيل|delivery)/i.test(v)) continue;
      if (n.parentElement && n.parentElement.closest('.cs-bar, .cs-modal, script, style, select, option')) continue;
      var nv = v.replace(CITY_IN_NOTE, '');
      if (nv !== v) n.nodeValue = nv;
    }
  }
  function cleanBirdNote() {
    if (!document.body || !/\/cart\/?$/.test(location.pathname)) return; // Bird's widget lives on the cart page
    cleanNoteIn(document.body);
    document.querySelectorAll('*').forEach(function (el) { if (el.shadowRoot) cleanNoteIn(el.shadowRoot); });
  }

  function renderAll() {
    var city = getCity();
    renderBar(city);
    renderCards(city);
    renderCart(city);
    syncBirdLocation(city);
    cleanBirdNote();
    if (city) renderForms(city);
  }

  /* ---------- add-to-cart guard ---------- */
  var origFetch = window.fetch.bind(window);
  function itemsFromBody(body) {
    var out = [];
    try {
      if (!body) return out;
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          if (j.items) j.items.forEach(function (i) { out.push({ id: i.id, qty: +i.quantity || 1 }); });
          else if (j.id) out.push({ id: j.id, qty: +j.quantity || 1 });
        } else {
          var sp = new URLSearchParams(body);
          if (sp.get('id')) out.push({ id: sp.get('id'), qty: +sp.get('quantity') || 1 });
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('id')) out.push({ id: body.get('id'), qty: +body.get('quantity') || 1 });
      } else if (body instanceof URLSearchParams) {
        if (body.get('id')) out.push({ id: body.get('id'), qty: +body.get('quantity') || 1 });
      }
    } catch (e) {}
    return out;
  }
  function getCart() {
    return origFetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function inCartQty(cart, vid) {
    return (cart.items || []).reduce(function (n, it) { return String(it.variant_id) === String(vid) ? n + it.quantity : n; }, 0);
  }
  /* copy a request body with new quantities: qtyFor(id) -> number */
  function rewriteBody(body, qtyFor) {
    if (typeof body === 'string') {
      if (body.trim().charAt(0) === '{') {
        var j = JSON.parse(body);
        if (j.items) {
          j.items = j.items.map(function (i) { i.quantity = qtyFor(i.id); return i; }).filter(function (i) { return i.quantity > 0; });
        } else { j.quantity = qtyFor(j.id || j.line); }
        return JSON.stringify(j);
      }
      var sp = new URLSearchParams(body);
      sp.set('quantity', qtyFor(sp.get('id') || sp.get('line')));
      return sp.toString();
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var fd = new FormData();
      body.forEach(function (v, k) { if (k !== 'quantity') fd.append(k, v); });
      fd.set('quantity', qtyFor(body.get('id') || body.get('line')));
      return fd;
    }
    if (body instanceof URLSearchParams) {
      var c = new URLSearchParams(body.toString());
      c.set('quantity', qtyFor(c.get('id') || c.get('line')));
      return c;
    }
    return body;
  }
  function readChange(url, body) {
    var o = {};
    try {
      var u = new URL(url, location.origin);
      if (u.searchParams.has('quantity')) {
        return { src: 'url', u: u, line: u.searchParams.get('line'), id: u.searchParams.get('id'), qty: +u.searchParams.get('quantity') };
      }
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') o = JSON.parse(body);
        else new URLSearchParams(body).forEach(function (v, k) { o[k] = v; });
      } else if (body && typeof body.get === 'function') {
        o = { line: body.get('line'), id: body.get('id'), quantity: body.get('quantity') };
      }
    } catch (e) {}
    if (o.quantity == null) return null;
    return { src: 'body', line: o.line, id: o.id, qty: +o.quantity };
  }
  function errorResponse(msg) {
    return new Response(JSON.stringify({ status: 422, message: msg, description: msg }), {
      status: 422, headers: { 'Content-Type': 'application/json' }
    });
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var city = getCity();

      /* Bird saving its delivery location: keep it on the chosen city */
      if (city && /\/cart\/update/.test(url) && init && init.body) {
        var fixed = fixBirdAttributes(init.body, city);
        if (fixed) {
          cfg.cartBirdLoc = BIRD[city].shopifyLocationId;
          return origFetch(input, Object.assign({}, init, { body: fixed }));
        }
      }

      /* Add to cart: add only what the city has left instead of rejecting */
      if (city && /\/cart\/add/.test(url) && init && init.body) {
        var items = itemsFromBody(init.body).filter(function (i) {
          var q = stockOf(i.id, city);
          return q !== null && q < 999;
        });
        if (items.length) {
          return getCart().then(function (cart) {
            var allowed = {}, changed = false, lastMsg = null, anyAdded = false;
            itemsFromBody(init.body).forEach(function (i) {
              var q = stockOf(i.id, city);
              if (q === null || q >= 999) { allowed[i.id] = i.qty; anyAdded = true; return; }
              var left = Math.max(Math.max(q, 0) - inCartQty(cart, i.id), 0);
              var take = Math.min(i.qty, left);
              allowed[i.id] = take;
              if (take > 0) anyAdded = true;
              if (take < i.qty) {
                changed = true;
                if (q > 0) rememberCap(i.id, inCartQty(cart, i.id) + i.qty, city);
                lastMsg = q <= 0 ? fmt(t.soldOutIn, { city: cityLabel(city) })
                  : take > 0 ? fmt(t.addedOnly, { n: q, city: cityLabel(city) })
                  : fmt(t.maxInCart, { n: q, city: cityLabel(city) });
              }
            });
            if (!changed) return origFetch(input, init);
            if (!anyAdded) { toast(lastMsg); return errorResponse(lastMsg); }
            var newInit = Object.assign({}, init, { body: rewriteBody(init.body, function (id) { return allowed[id] != null ? allowed[id] : 1; }) });
            return origFetch(input, newInit).then(function (res) { if (res.ok) toast(lastMsg); return res; });
          }).catch(function () { return origFetch(input, init); });
        }
      }

      /* Quantity changed in the cart: cap at the city's stock */
      if (city && /\/cart\/change/.test(url) && typeof input === 'string') {
        var ch = readChange(url, init && init.body);
        if (ch && ch.qty > 0) {
          return getCart().then(function (cart) {
            var item = ch.line ? cart.items[parseInt(ch.line, 10) - 1]
              : (cart.items || []).filter(function (it) { return it.key === ch.id || String(it.variant_id) === String(ch.id) || String(it.id) === String(ch.id); })[0];
            var q = item ? stockOf(item.variant_id, city) : null;
            if (q === null || q >= 999 || ch.qty <= q) return origFetch(input, init);
            var nq = q > 0 ? q : item.quantity;
            if (q > 0) rememberCap(item.variant_id, ch.qty, city);
            var msg = q > 0 ? fmt(t.capped, { n: q, city: cityLabel(city) }) : fmt(t.soldOutIn, { city: cityLabel(city) });
            var p;
            if (ch.src === 'url') { ch.u.searchParams.set('quantity', nq); p = origFetch(ch.u.toString(), init); }
            else p = origFetch(input, Object.assign({}, init, { body: rewriteBody(init.body, function () { return nq; }) }));
            return p.then(function (res) { toast(msg); return res; });
          }).catch(function () { return origFetch(input, init); });
        }
      }
    } catch (e) {}
    return origFetch(input, init);
  };

  /* ---------- checkout guard ---------- */
  function checkCart(fromCheckout) {
    var city = getCity();
    if (!city) return Promise.resolve(true);
    return origFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var issues = [];
        (cart.items || []).forEach(function (it) {
          var q = stockOf(it.variant_id, city);
          if (q !== null && it.quantity > q) {
            issues.push('<li><strong>' + escapeHtml(it.product_title) + '</strong> — ' +
              (q <= 0 ? fmt(t.soldOutIn, { city: cityLabel(city) }) : fmt(t.notEnough, { n: q, city: cityLabel(city) })) + '</li>');
          }
        });
        if (!issues.length) return true;
        openModal(
          '<h2 class="cs-modal__title" id="cs-title">' + fmt(t.cartIssues, { city: cityLabel(city) }) + '</h2>' +
          '<ul class="cs-modal__issues">' + issues.join('') + '</ul>' +
          '<p class="cs-modal__sub">' + t.cartFix + '</p>' +
          '<button type="button" class="cs-modal__ok">' + t.ok + '</button>',
          function (m) {
            var ok = m.querySelector('.cs-modal__ok');
            ok.focus();
            ok.addEventListener('click', closeModal);
            m.querySelector('.cs-modal__bg').addEventListener('click', closeModal);
          }
        );
        return false;
      })
      .catch(function () { return true; });
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  var passing = false;
  document.addEventListener('click', function (e) {
    if (passing) return;
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!el) return;
    if (!getCity()) { e.preventDefault(); e.stopImmediatePropagation(); openCityPicker(); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    checkCart(true).then(function (ok) {
      if (!ok) return;
      passing = true;
      if (el.tagName === 'A') { window.location.href = el.href; return; }
      var form = el.form || el.closest('form');
      if (form) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
        form.appendChild(h);
        HTMLFormElement.prototype.submit.call(form);
      } else {
        window.location.href = '/checkout';
      }
    });
  }, true);

  /* ---------- boot ---------- */
  function boot() {
    // ?city=jeddah / ?city=riyadh in links (ads, WhatsApp) pre-selects the city
    try {
      var qp = new URLSearchParams(location.search).get('city');
      if (qp && cfg.cities[qp.toLowerCase()]) setCityStore(qp.toLowerCase());
    } catch (e) {}

    var city = getCity();
    if (city) syncCartAttribute(city);
    renderAll();

    if (!city && !cfg.designMode) setTimeout(function () { if (!getCity()) openCityPicker(); }, cfg.delay);

    // keep product forms / new cards in sync with variant switches & AJAX-loaded content
    var pending = false;
    var schedule = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; var c = getCity(); renderCards(c); renderCart(c); if (c) renderForms(c); });
    };
    document.addEventListener('change', schedule, true);
    setInterval(function () { var c = getCity(); if (c) { renderForms(c); renderCart(c); syncBirdLocation(c); } cleanBirdNote(); }, 600);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].addedNodes;
        for (var k = 0; k < n.length; k++) {
          if (n[k].nodeType === 1 && !n[k].classList.contains('cs-badge') && !n[k].classList.contains('cs-status') && !n[k].classList.contains('cs-line-flag') && !n[k].classList.contains('cs-checkout-note') &&
              (n[k].matches('[data-js-product-item], [data-js-cart-item], form') || n[k].querySelector('[data-js-product-item], [data-js-cart-item], form[action*="/cart/add"]'))) {
            schedule(); return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
